// TODO remove user as parameter
// And perhaps move this somewhere else
export function userHasPerm(user, perm) {
  const org = this.$store.get("currentOrganisation")
  return org?.permissions?.includes(perm)
}
